var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Mic, MicOff, PhoneOff, Volume2, Loader2, Send, Bot, Check } from 'lucide-react';
import { Room, RoomEvent, Track } from 'livekit-client';
import { loadEdgeSdk } from '../edge/edgeSdkLoader';
import { RemoteAvatar } from '../edge/remoteAvatar';
import { getAvatarConfig } from '../config/avatarConfig';
var LOADER_STEPS = [
    { key: 'avatar', label: 'Loading avatar' },
    { key: 'token', label: 'Securing session' },
    { key: 'connecting', label: 'Connecting to agent' },
];
var EdgeAvatarMode = function (_a) {
    var config = _a.config, email = _a.email, contact = _a.contact, domain = _a.domain, _b = _a.mode, mode = _b === void 0 ? 'avatar' : _b, isCircle = _a.isCircle, onConnectedChange = _a.onConnectedChange, onEnd = _a.onEnd;
    var cfg = React.useMemo(function () { return getAvatarConfig(config); }, [config]);
    var canvasRef = React.useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var avatarRef = React.useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sessionRef = React.useRef(null);
    var mountedRef = React.useRef(true);
    var _c = React.useState('Starting…'), status = _c[0], setStatus = _c[1];
    // Connection phases drive the animated loader.
    var _d = React.useState('avatar'), phase = _d[0], setPhase = _d[1];
    var _e = React.useState(0), loadPct = _e[0], setLoadPct = _e[1];
    var _f = React.useState(false), connected = _f[0], setConnected = _f[1];
    var _g = React.useState(false), muted = _g[0], setMuted = _g[1];
    var _h = React.useState(100), volume = _h[0], setVolume = _h[1];
    var _j = React.useState(false), showVolume = _j[0], setShowVolume = _j[1];
    // Browser autoplay can block the agent's audio until a user gesture.
    var _k = React.useState(false), audioBlocked = _k[0], setAudioBlocked = _k[1];
    var _l = React.useState(null), error = _l[0], setError = _l[1];
    var _m = React.useState([]), captions = _m[0], setCaptions = _m[1];
    var _o = React.useState(''), composerText = _o[0], setComposerText = _o[1];
    var captionsRef = React.useRef(null);
    // Mirrors `connected` for use inside stable callbacks (avoids stale closure).
    var connectedRef = React.useRef(false);
    var upsertCaption = React.useCallback(function (c) {
        setCaptions(function (prev) {
            var idx = prev.findIndex(function (p) { return p.id === c.id; });
            var next;
            if (idx === -1)
                next = __spreadArray(__spreadArray([], prev, true), [c], false);
            else {
                next = prev.slice();
                next[idx] = c;
            }
            return next.slice(-30);
        });
    }, []);
    // Auto-scroll captions to the latest line.
    React.useEffect(function () {
        var el = captionsRef.current;
        if (el)
            el.scrollTop = el.scrollHeight;
    }, [captions]);
    /** Token for this session — same endpoint and params in both render modes. */
    var fetchToken = React.useCallback(function (render) { return __awaiter(void 0, void 0, void 0, function () {
        var params, res, data, serverUrl, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = new URLSearchParams({
                        domain: domain || window.location.hostname,
                        mode: mode,
                        email: email || '',
                        contact: contact || '',
                        render: render,
                        avatarId: cfg.avatar,
                    });
                    return [4 /*yield*/, fetch("".concat(cfg.tokenApiUrl, "?").concat(params.toString()), {
                            method: 'GET',
                            headers: { Accept: 'application/json' },
                        })];
                case 1:
                    res = _a.sent();
                    if (!res.ok)
                        throw new Error("Token endpoint ".concat(res.status));
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    serverUrl = data.livekit_url || data.server_url || data.url || data.serverUrl;
                    token = data.participant_token || data.token || data.participantToken;
                    if (!serverUrl || !token)
                        throw new Error('Token endpoint returned no serverUrl/token');
                    return [2 /*return*/, { serverUrl: serverUrl, token: token, roomName: data.room_name || data.roomName }];
            }
        });
    }); }, [cfg.tokenApiUrl, cfg.avatar, domain, mode, email, contact]);
    // Remote render: frames come from the GPU renderer via the gateway, so the
    // browser downloads no models and never touches WebGPU. We drive LiveKit
    // ourselves here — the edge SDK is only for the in-browser canvas path.
    var startRemote = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var avatar, _a, serverUrl, token, audioCtx, room;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setStatus('Loading avatar…');
                    setPhase('avatar');
                    avatar = new RemoteAvatar({
                        gatewayUrl: cfg.gatewayUrl,
                        avatarId: cfg.avatar,
                        canvas: canvasRef.current,
                        onError: function (e) { return console.warn('[EdgeAvatarMode] render step failed', e); },
                    });
                    // Warms the renderer session (cold avatar bundles take ~10-15s upstream).
                    return [4 /*yield*/, avatar.load()];
                case 1:
                    // Warms the renderer session (cold avatar bundles take ~10-15s upstream).
                    _b.sent();
                    if (!mountedRef.current)
                        return [2 /*return*/];
                    avatarRef.current = avatar;
                    // Handy in the console: __talkbotRemote.stats shows speech vs idle steps.
                    window.__talkbotRemote = avatar;
                    setStatus('Securing session…');
                    setPhase('token');
                    return [4 /*yield*/, fetchToken('local')];
                case 2:
                    _a = _b.sent(), serverUrl = _a.serverUrl, token = _a.token;
                    if (!mountedRef.current)
                        return [2 /*return*/];
                    setStatus('Connecting to agent…');
                    setPhase('connecting');
                    audioCtx = new AudioContext();
                    room = new Room();
                    room.registerTextStreamHandler('lk.transcription', function (reader, info) { return __awaiter(void 0, void 0, void 0, function () {
                        var attrs, id, isLocal, text, chunk, e_1_1, _a;
                        var _b, reader_1, reader_1_1;
                        var _c, e_1, _d, _e;
                        var _f, _g;
                        return __generator(this, function (_h) {
                            switch (_h.label) {
                                case 0:
                                    attrs = ((_f = reader.info) === null || _f === void 0 ? void 0 : _f.attributes) || {};
                                    id = attrs['lk.segment_id'] || reader.info.id;
                                    isLocal = (info === null || info === void 0 ? void 0 : info.identity) === room.localParticipant.identity;
                                    text = '';
                                    _h.label = 1;
                                case 1:
                                    _h.trys.push([1, 14, , 15]);
                                    _h.label = 2;
                                case 2:
                                    _h.trys.push([2, 7, 8, 13]);
                                    _b = true, reader_1 = __asyncValues(reader);
                                    _h.label = 3;
                                case 3: return [4 /*yield*/, reader_1.next()];
                                case 4:
                                    if (!(reader_1_1 = _h.sent(), _c = reader_1_1.done, !_c)) return [3 /*break*/, 6];
                                    _e = reader_1_1.value;
                                    _b = false;
                                    chunk = _e;
                                    text += chunk;
                                    upsertCaption({ id: id, text: text, role: isLocal ? 'user' : 'agent', final: false });
                                    _h.label = 5;
                                case 5:
                                    _b = true;
                                    return [3 /*break*/, 3];
                                case 6: return [3 /*break*/, 13];
                                case 7:
                                    e_1_1 = _h.sent();
                                    e_1 = { error: e_1_1 };
                                    return [3 /*break*/, 13];
                                case 8:
                                    _h.trys.push([8, , 11, 12]);
                                    if (!(!_b && !_c && (_d = reader_1.return))) return [3 /*break*/, 10];
                                    return [4 /*yield*/, _d.call(reader_1)];
                                case 9:
                                    _h.sent();
                                    _h.label = 10;
                                case 10: return [3 /*break*/, 12];
                                case 11:
                                    if (e_1) throw e_1.error;
                                    return [7 /*endfinally*/];
                                case 12: return [7 /*endfinally*/];
                                case 13: return [3 /*break*/, 15];
                                case 14:
                                    _a = _h.sent();
                                    return [3 /*break*/, 15];
                                case 15:
                                    upsertCaption({
                                        id: id,
                                        text: text,
                                        role: isLocal ? 'user' : 'agent',
                                        final: ((_g = attrs['lk.transcription_final']) !== null && _g !== void 0 ? _g : 'true') === 'true',
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    room.on(RoomEvent.TrackSubscribed, function (track, _pub, participant) {
                        // The agent's voice is NOT attached to an <audio> element: RemoteAvatar
                        // plays it through a DelayNode so it lands with its rendered frames.
                        if (track.kind === Track.Kind.Audio && !participant.isLocal) {
                            avatar.start(track.mediaStreamTrack, audioCtx);
                            avatar.setVolume(volume / 100);
                        }
                    });
                    room.on(RoomEvent.Disconnected, function () {
                        if (!mountedRef.current)
                            return;
                        connectedRef.current = false;
                        setConnected(false);
                        onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(false);
                        setStatus('Disconnected.');
                    });
                    return [4 /*yield*/, room.connect(serverUrl, token)];
                case 3:
                    _b.sent();
                    // Don't await the mic: a pending permission prompt would otherwise hold the
                    // UI on "Connecting" indefinitely, and a denied mic still leaves a usable
                    // session (text input and the avatar keep working).
                    void room.localParticipant
                        .setMicrophoneEnabled(true)
                        .catch(function (e) { return console.warn('[EdgeAvatarMode] microphone unavailable', e); });
                    if (!mountedRef.current) {
                        room.disconnect();
                        return [2 /*return*/];
                    }
                    // WebAudio starts suspended without a gesture on fresh origins — same
                    // symptom as blocked autoplay, same prompt.
                    if (audioCtx.state !== 'running')
                        setAudioBlocked(true);
                    sessionRef.current = {
                        room: room,
                        audioContext: audioCtx,
                        setMicEnabled: function (enabled) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, room.localParticipant.setMicrophoneEnabled(enabled)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/, enabled];
                                }
                            });
                        }); },
                        setVolume: function (v) { return avatar.setVolume(v); },
                        disconnect: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        avatar.stop();
                                        return [4 /*yield*/, room.disconnect()];
                                    case 1:
                                        _b.sent();
                                        _b.label = 2;
                                    case 2:
                                        _b.trys.push([2, 4, , 5]);
                                        return [4 /*yield*/, audioCtx.close()];
                                    case 3:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 4:
                                        _a = _b.sent();
                                        return [3 /*break*/, 5];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); },
                    };
                    connectedRef.current = true;
                    setConnected(true);
                    onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(true);
                    setPhase('live');
                    setStatus('Connected — say something or type a message!');
                    return [2 /*return*/];
            }
        });
    }); }, [cfg.gatewayUrl, cfg.avatar, fetchToken, upsertCaption, volume]);
    React.useEffect(function () {
        mountedRef.current = true;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var sdk, avatar_1, _a, serverUrl, token, roomName, session, room_1, syncAudioState, err_1, msg;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 7, , 8]);
                        if (!(cfg.render === 'gateway')) return [3 /*break*/, 2];
                        return [4 /*yield*/, startRemote()];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                    case 2: return [4 /*yield*/, loadEdgeSdk(cfg.sdkUrl)];
                    case 3:
                        sdk = _d.sent();
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        // 1) Build + load the avatar on our canvas.
                        setStatus('Loading avatar…');
                        setPhase('avatar');
                        avatar_1 = new sdk.TalkbotAvatar({
                            canvas: canvasRef.current,
                            assetBase: cfg.assetBase,
                            avatar: cfg.avatar,
                            modelBase: cfg.modelBase,
                            feat: 'int8',
                            background: 'idle',
                            crossfade: true,
                            crossfadeFrames: 5,
                            idleHoldSeconds: 1.0,
                            idleOrder: cfg.idleOrder,
                            sharpen: 1.1,
                            viewMaxDim: 1080,
                            streamChunkBlocks: 13,
                            audioDelaySeconds: 0.82,
                            showFps: false,
                            onProgress: function (received, total, _phase) {
                                // Secondary models (e.g. wenet) stream in lazily after connect —
                                // don't resurrect the loading overlay once we're live.
                                if (!mountedRef.current || connectedRef.current)
                                    return;
                                var pct = total ? Math.round((received / total) * 100) : 0;
                                setLoadPct(pct);
                            },
                            onEvent: function (name, detail) {
                                if (!mountedRef.current)
                                    return;
                                if (name === 'error')
                                    setStatus("Error: ".concat((detail === null || detail === void 0 ? void 0 : detail.message) || detail));
                            },
                        });
                        return [4 /*yield*/, avatar_1.load()];
                    case 4:
                        _d.sent();
                        if (!mountedRef.current) {
                            (_b = avatar_1.dispose) === null || _b === void 0 ? void 0 : _b.call(avatar_1);
                            return [2 /*return*/];
                        }
                        avatarRef.current = avatar_1;
                        // 2) Fetch a fresh LiveKit token + room from the token API.
                        setStatus('Securing session…');
                        setPhase('token');
                        return [4 /*yield*/, fetchToken('local')];
                    case 5:
                        _a = _d.sent(), serverUrl = _a.serverUrl, token = _a.token, roomName = _a.roomName;
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        // 3) Connect the voice agent — drives the avatar's lip-sync.
                        setStatus('Connecting to agent…');
                        setPhase('connecting');
                        return [4 /*yield*/, sdk.connectLiveKit({
                                avatar: avatar_1,
                                serverUrl: serverUrl,
                                token: token,
                                room: roomName,
                                initialVolume: volume / 100,
                                onStatus: function (state, detail) {
                                    if (!mountedRef.current)
                                        return;
                                    if (state === 'connected') {
                                        connectedRef.current = true;
                                        setConnected(true);
                                        onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(true);
                                        setMuted(false);
                                        setPhase('live');
                                        setStatus('Connected — say something or type a message!');
                                    }
                                    else if (state === 'disconnected') {
                                        connectedRef.current = false;
                                        setConnected(false);
                                        onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(false);
                                        setStatus('Disconnected.');
                                    }
                                    else if (state === 'error' || state === 'warn') {
                                        setStatus("Agent: ".concat(detail));
                                    }
                                },
                                onCaption: function (_a) {
                                    var id = _a.id, text = _a.text, role = _a.role, final = _a.final;
                                    return upsertCaption({ id: id, text: text, role: role, final: final });
                                },
                                onData: function () { },
                            })];
                    case 6:
                        session = _d.sent();
                        if (!mountedRef.current) {
                            (_c = session.disconnect) === null || _c === void 0 ? void 0 : _c.call(session);
                            return [2 /*return*/];
                        }
                        sessionRef.current = session;
                        room_1 = session === null || session === void 0 ? void 0 : session.room;
                        if (room_1) {
                            room_1.on('trackMuted', function (pub, p) {
                                if (!p.isLocal && pub.kind === 'audio')
                                    avatar_1.setSpeaking(false);
                            });
                            room_1.on('trackUnmuted', function (pub, p) {
                                if (!p.isLocal && pub.kind === 'audio')
                                    avatar_1.setSpeaking(true);
                            });
                            syncAudioState = function () {
                                if (mountedRef.current)
                                    setAudioBlocked(room_1.canPlaybackAudio === false);
                            };
                            syncAudioState();
                            room_1.on('audioPlaybackStatusChanged', syncAudioState);
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _d.sent();
                        if (!mountedRef.current)
                            return [2 /*return*/];
                        msg = err_1 instanceof Error ? err_1.message : String(err_1);
                        setError(msg);
                        setStatus("Failed: ".concat(msg));
                        setPhase('error');
                        console.error('[EdgeAvatarMode]', err_1);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            var _a, _b, _c, _d, _e, _f;
            mountedRef.current = false;
            if (connectedRef.current) {
                connectedRef.current = false;
                onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(false);
            }
            try {
                (_b = (_a = sessionRef.current) === null || _a === void 0 ? void 0 : _a.disconnect) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            catch (_g) { }
            sessionRef.current = null;
            try {
                (_d = (_c = avatarRef.current) === null || _c === void 0 ? void 0 : _c.dispose) === null || _d === void 0 ? void 0 : _d.call(_c);
                (_f = (_e = avatarRef.current) === null || _e === void 0 ? void 0 : _e.stop) === null || _f === void 0 ? void 0 : _f.call(_e);
            }
            catch (_h) { }
            avatarRef.current = null;
        };
        // Connect once on mount; cfg/email/contact are stable for a session.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Safety net: the first user interaction after connect resumes audio playback
    // (covers browsers that suspend the audio context until any gesture).
    React.useEffect(function () {
        if (!connected)
            return;
        var resume = function () { return __awaiter(void 0, void 0, void 0, function () {
            var session, _a, _b, _c;
            var _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        session = sessionRef.current;
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ((_e = (_d = session === null || session === void 0 ? void 0 : session.room) === null || _d === void 0 ? void 0 : _d.startAudio) === null || _e === void 0 ? void 0 : _e.call(_d))];
                    case 2:
                        _m.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _m.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        _m.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, ((_g = (_f = session === null || session === void 0 ? void 0 : session.audioContext) === null || _f === void 0 ? void 0 : _f.resume) === null || _g === void 0 ? void 0 : _g.call(_f))];
                    case 5:
                        _m.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _b = _m.sent();
                        return [3 /*break*/, 7];
                    case 7:
                        _m.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, ((_k = (_j = (_h = avatarRef.current) === null || _h === void 0 ? void 0 : _h.audioContext) === null || _j === void 0 ? void 0 : _j.resume) === null || _k === void 0 ? void 0 : _k.call(_j))];
                    case 8:
                        _m.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        _c = _m.sent();
                        return [3 /*break*/, 10];
                    case 10:
                        if (((_l = session === null || session === void 0 ? void 0 : session.room) === null || _l === void 0 ? void 0 : _l.canPlaybackAudio) !== false)
                            setAudioBlocked(false);
                        return [2 /*return*/];
                }
            });
        }); };
        window.addEventListener('pointerdown', resume, { once: true, capture: true });
        return function () { return window.removeEventListener('pointerdown', resume, true); };
    }, [connected]);
    // Unblock audio playback from a user gesture (resumes LiveKit's audio context
    // and the avatar's, so both sound and lip-sync start).
    var enableAudio = function () { return __awaiter(void 0, void 0, void 0, function () {
        var session, e_2, _a, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    session = sessionRef.current;
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ((_d = (_c = session === null || session === void 0 ? void 0 : session.room) === null || _c === void 0 ? void 0 : _c.startAudio) === null || _d === void 0 ? void 0 : _d.call(_c))];
                case 2:
                    _l.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _l.sent();
                    console.warn('[EdgeAvatarMode] startAudio failed', e_2);
                    return [3 /*break*/, 4];
                case 4:
                    _l.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, ((_f = (_e = session === null || session === void 0 ? void 0 : session.audioContext) === null || _e === void 0 ? void 0 : _e.resume) === null || _f === void 0 ? void 0 : _f.call(_e))];
                case 5:
                    _l.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _a = _l.sent();
                    return [3 /*break*/, 7];
                case 7:
                    _l.trys.push([7, 9, , 10]);
                    return [4 /*yield*/, ((_j = (_h = (_g = avatarRef.current) === null || _g === void 0 ? void 0 : _g.audioContext) === null || _h === void 0 ? void 0 : _h.resume) === null || _j === void 0 ? void 0 : _j.call(_h))];
                case 8:
                    _l.sent();
                    return [3 /*break*/, 10];
                case 9:
                    _b = _l.sent();
                    return [3 /*break*/, 10];
                case 10:
                    if (((_k = session === null || session === void 0 ? void 0 : session.room) === null || _k === void 0 ? void 0 : _k.canPlaybackAudio) !== false)
                        setAudioBlocked(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleMute = function () { return __awaiter(void 0, void 0, void 0, function () {
        var session, enabled, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    session = sessionRef.current;
                    if (!session)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, session.setMicEnabled(muted)];
                case 2:
                    enabled = _a.sent();
                    setMuted(!enabled);
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    console.error('[EdgeAvatarMode] mute toggle failed', e_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onVolumeChange = function (v) {
        var _a, _b;
        setVolume(v);
        (_b = (_a = sessionRef.current) === null || _a === void 0 ? void 0 : _a.setVolume) === null || _b === void 0 ? void 0 : _b.call(_a, v / 100);
    };
    var sendMessage = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var text, session, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    text = composerText.trim();
                    session = sessionRef.current;
                    if (!text || !(session === null || session === void 0 ? void 0 : session.room))
                        return [2 /*return*/];
                    setComposerText('');
                    // Echo locally right away.
                    upsertCaption({ id: "local-".concat(captions.length, "-").concat(text.length), text: text, role: 'user', final: true });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, session.room.localParticipant.sendText(text, { topic: 'lk.chat' })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.error('[EdgeAvatarMode] send failed', err_2);
                    setStatus("Send failed: ".concat(err_2 instanceof Error ? err_2.message : String(err_2)));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var endSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ((_c = (_b = sessionRef.current) === null || _b === void 0 ? void 0 : _b.disconnect) === null || _c === void 0 ? void 0 : _c.call(_b))];
                case 1:
                    _d.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _d.sent();
                    return [3 /*break*/, 3];
                case 3:
                    sessionRef.current = null;
                    if (connectedRef.current) {
                        connectedRef.current = false;
                        onConnectedChange === null || onConnectedChange === void 0 ? void 0 : onConnectedChange(false);
                    }
                    onEnd === null || onEnd === void 0 ? void 0 : onEnd();
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "talkbot-edge-avatar", style: isCircle ? { borderRadius: '50%', overflow: 'hidden' } : undefined },
        React.createElement("div", { className: "talkbot-edge-stage" },
            React.createElement("canvas", { ref: canvasRef, width: 540, height: 960, className: "talkbot-edge-canvas" })),
        phase !== 'live' && phase !== 'error' && (React.createElement("div", { className: "talkbot-edge-loader" },
            React.createElement("div", { className: "talkbot-edge-orb" },
                React.createElement("span", { className: "talkbot-edge-orb-ring" }),
                React.createElement("span", { className: "talkbot-edge-orb-ring talkbot-edge-orb-ring--2" }),
                React.createElement("span", { className: "talkbot-edge-orb-ring talkbot-edge-orb-ring--3" }),
                React.createElement("span", { className: "talkbot-edge-orb-core" },
                    React.createElement(Bot, { size: 30 }))),
            React.createElement("div", { className: "talkbot-edge-loader-title" }, "Connecting to your assistant"),
            React.createElement("ul", { className: "talkbot-edge-steps" }, LOADER_STEPS.map(function (s, i) {
                var stepIndex = phase === 'avatar' ? 0 : phase === 'token' ? 1 : 2;
                var active = i === stepIndex;
                var done = i < stepIndex;
                return (React.createElement("li", { key: s.key, className: "talkbot-edge-step".concat(active ? ' is-active' : '').concat(done ? ' is-done' : '') },
                    React.createElement("span", { className: "talkbot-edge-step-icon" }, done ? (React.createElement(Check, { size: 13 })) : active ? (React.createElement(Loader2, { size: 13, className: "talkbot-edge-spin" })) : (React.createElement("span", { className: "talkbot-edge-step-dot" }))),
                    React.createElement("span", { className: "talkbot-edge-step-label" },
                        s.label,
                        active && s.key === 'avatar' && loadPct > 0
                            ? " ".concat(loadPct, "%")
                            : '',
                        active && (React.createElement("span", { className: "talkbot-edge-dots" },
                            React.createElement("i", null),
                            React.createElement("i", null),
                            React.createElement("i", null))))));
            })),
            React.createElement("div", { className: "talkbot-edge-progress" },
                React.createElement("span", { className: "talkbot-edge-progress-bar".concat(phase === 'avatar' && loadPct > 0 ? ' is-determinate' : ''), style: phase === 'avatar' && loadPct > 0
                        ? { width: "".concat(loadPct, "%") }
                        : undefined })))),
        error && (React.createElement("div", { className: "talkbot-edge-overlay" },
            React.createElement("div", { style: { fontSize: 28, marginBottom: 8 } }, "\u26A0\uFE0F"),
            React.createElement("span", { style: { maxWidth: 260, textAlign: 'center' } }, error),
            React.createElement("button", { className: "talkbot-edge-retrybtn", onClick: endSession }, "Back"))),
        audioBlocked && phase === 'live' && !error && (React.createElement("button", { className: "talkbot-edge-audio-gate", onClick: enableAudio },
            React.createElement(Volume2, { size: 22 }),
            React.createElement("span", null, "Tap to enable sound"))),
        !error && (React.createElement("div", { className: "talkbot-edge-topbar" },
            showVolume && (React.createElement("div", { className: "talkbot-edge-volpop" },
                React.createElement("input", { type: "range", min: 0, max: 100, value: volume, disabled: !connected, onChange: function (e) { return onVolumeChange(Number(e.target.value)); }, "aria-label": "Voice volume", autoFocus: true }))),
            React.createElement("button", { className: "talkbot-edge-ctrl talkbot-edge-ctrl--sm ".concat(showVolume ? 'is-active' : ''), onClick: function () { return setShowVolume(function (s) { return !s; }); }, disabled: !connected, title: "Volume", "aria-label": "Voice volume", "aria-expanded": showVolume },
                React.createElement(Volume2, { size: 16 })),
            React.createElement("button", { className: "talkbot-edge-ctrl talkbot-edge-ctrl--sm talkbot-edge-ctrl--end", onClick: endSession, title: "End", "aria-label": "End session" },
                React.createElement(PhoneOff, { size: 16 })))),
        phase === 'live' && !error && captions.length === 0 && (React.createElement("div", { className: "talkbot-edge-status" }, status)),
        captions.length > 0 && (React.createElement("div", { ref: captionsRef, className: "talkbot-edge-captions" }, captions.map(function (c) { return (React.createElement("div", { key: c.id, className: "talkbot-edge-caption talkbot-edge-caption--".concat(c.role, " ").concat(c.final ? '' : 'is-interim') },
            React.createElement("span", { className: "talkbot-edge-caption-who" }, c.role === 'agent' ? 'Agent' : 'You'),
            c.text)); }))),
        !error && (React.createElement("form", { className: "talkbot-edge-composer", onSubmit: sendMessage },
            React.createElement("button", { type: "button", className: "talkbot-edge-ctrl talkbot-edge-ctrl--sm ".concat(muted ? 'is-muted' : ''), onClick: toggleMute, disabled: !connected, title: muted ? 'Unmute' : 'Mute', "aria-label": muted ? 'Unmute microphone' : 'Mute microphone' }, muted ? React.createElement(MicOff, { size: 17 }) : React.createElement(Mic, { size: 17 })),
            React.createElement("input", { className: "talkbot-edge-composer-input", type: "text", value: composerText, onChange: function (e) { return setComposerText(e.target.value); }, placeholder: connected ? 'Type a message…' : 'Connecting…', disabled: !connected, autoComplete: "off", enterKeyHint: "send" }),
            React.createElement("button", { type: "submit", className: "talkbot-edge-ctrl talkbot-edge-ctrl--sm talkbot-edge-ctrl--send", disabled: !connected || !composerText.trim(), title: "Send", "aria-label": "Send message" },
                React.createElement(Send, { size: 16 }))))));
};
export default EdgeAvatarMode;
